// // import React, { useState } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import Popup from "../../../../ResuableCompoment/Popup";
// // import useApi from "../../../../CustomHooks/useApi";
// // import BankSelect from "../../../../ResuableCompoment/BankSelect";
// // import { useSelector, useDispatch } from "react-redux";
// // import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../../Store/Slices/WalletSlice";
// // import bankList from "./banklist.json";

// // const AddBeneficiary = () => {

// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();

// //   const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
// //   const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
// //   const username = useSelector((store) => store.auth.employeeDetails.username);
// //   const [bankSearch, setBankSearch] = useState("");
// //   const [showBankList, setShowBankList] = useState(false);

// //   const impsType = useSelector(
// //     (state) => state.auth.remitterData?.type
// //   );

// //   const [showOtpInput, setShowOtpInput] = useState(false);
// //   const [otp, setOtp] = useState("");
// //   const [otpToken, setOtpToken] = useState("");
// //   const [selectedBankIfsc, setSelectedBankIfsc] = useState("");

// //   const [bank, setBank] = useState("");
// //   const [ifscCode, setIfscCode] = useState("");
// //   const [bankcode, setBankcode] = useState("");
// //   const [accountHolderName, setAccountHolderName] = useState("");
// //   const [accountNumber, setAccountNumber] = useState("");
// //   const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
// //   const [mpin, setMpin] = useState("");
// //   const [mobileNumber, setMobileNumber] = useState("");
// //   const [errors, setErrors] = useState({});
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [selectedBankId, setSelectedBankId] = useState("");
// //   const [selectedBankName, setSelectedBankName] = useState("");
// //   const SUCCESS_STATUSES = ["SUCCESS", "APPROVED", "ACTIVE"];

// //   const [popupMessage, setPopupMessage] = useState("");
// //   const [popupType, setPopupType] = useState("");
// //   const [showPopup, setShowPopup] = useState(false);
// //   const [navigateTo, setNavigateTo] = useState(null);
// //   const [navigateState, setNavigateState] = useState(null);

// //   const showPopupMessage = (message, type, navigateTo = null, navigateState = null) => {
// //     setPopupMessage(message);
// //     setPopupType(type);
// //     setNavigateTo(navigateTo);
// //     setNavigateState(navigateState);
// //     setShowPopup(true);
// //   };

// //   const txnId = `DMT${new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 14)}${Math.floor(1000 + Math.random() * 9000)}`;

// //   const { callApi: addbeni } = useApi("/dmt/add/beneficiary", "POST");

// //   const handleConfirm = async () => {
// //     const newErrors = {};

// //     // ---------- COMMON ----------
// //     if (!accountHolderName) {
// //       newErrors.accountHolderName = "Account Holder Name is required.";
// //     } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
// //       newErrors.accountHolderName =
// //         "Account Holder Name can contain only alphabets and spaces.";
// //     }

// //     if (!accountNumber || accountNumber.length < 6 || accountNumber.length > 20) {
// //       newErrors.accountNumber =
// //         "Account Number must be between 6 and 20 digits.";
// //     }

// //     if (confirmAccountNumber !== accountNumber) {
// //       newErrors.confirmAccountNumber = "Account numbers do not match.";
// //     }

// //     if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
// //       newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
// //     }

// //     if (!mpin || !/^\d{6}$/.test(mpin)) {
// //       newErrors.mpin = "MPIN must be exactly 6 digits.";
// //     }

// //     // ---------- IMPS2 (ORIGINAL) ----------
// //     if (impsType === "IMPS2") {
// //       if (!bank) newErrors.bank = "Please select a bank";
// //       if (!ifscCode) newErrors.ifscCode = "IFSC code is required";
// //     }

// //     // ---------- IMPS1 (NEW) ----------
// //     if (impsType === "IMPS1") {
// //       if (!selectedBankId) newErrors.bank = "Please select a bank";
// //       if (!selectedBankIfsc)
// //         newErrors.ifscCode = "Selected bank does not have a valid IFSC";
// //     }

// //     // ---------- OTP (IMPS1 STEP 2) ----------
// //     if (impsType === "IMPS1" && showOtpInput) {
// //       if (!otp || !/^\d{4}(\d{2})?$/.test(otp)) {
// //         newErrors.otp = "Enter a valid 4 or 6 digit OTP.";
// //       }
// //     }

// //     if (Object.keys(newErrors).length > 0) {
// //       setErrors(newErrors);
// //       return;
// //     }

// //     setIsLoading(true);

// //     try {
// //       // ================= IMPS2 (ORIGINAL PAYLOAD) =================
// //       if (impsType === "IMPS2") {
// //         const imps2Payload = {
// //           remitterPhoneNumber: remitter_mobile_number,
// //           remitterName: remitter_fullname,
// //           beneficiaryName: accountHolderName,
// //           beneficiaryPhoneNumber: mobileNumber,
// //           bankName: bank,
// //           bankIfscCode: ifscCode,
// //           accountNumber,
// //           user_name: username,
// //           mpin,
// //           bank_code: bankcode,
// //           type: "IMPS2"
// //         };

// //         const res = await addbeni(imps2Payload);

// //         const SUCCESS_STATUSES = ["SUCCESS", "APPROVED", "ACTIVE"];

// //         if (
// //           res?.beneficiary_id &&
// //           SUCCESS_STATUSES.includes(res?.beneficiary_status)
// //         ) {
// //           setPopupMessage("Beneficiary added successfully.");
// //           setPopupType("success");
// //           setNavigateTo("/remittance");
// //           setShowPopup(true);
// //           return;
// //         }

// //         if (res?.beneficiary_status) {
// //           throw new Error(
// //             res?.message ||
// //             `Failed to add beneficiary (${res.beneficiary_status})`
// //           );
// //         }

// //         // 👇 HANDLE FAILURE EVEN IF ID EXISTS
// //         if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
// //           throw new Error(
// //             "Beneficiary could not be added due to insufficient wallet balance."
// //           );
// //         }

// //         throw new Error(res?.message || "Failed to add beneficiary");
// //       }

// //       // ================= IMPS1 (NEW PAYLOAD) =================
// //       const imps1Payload = {
// //         remitterPhoneNumber: remitter_mobile_number,
// //         remitterName: remitter_fullname,
// //         beneficiaryName: accountHolderName,
// //         beneficiaryPhoneNumber: mobileNumber,
// //         accountNumber,
// //         bankName: selectedBankId,
// //         bank_code: selectedBankId,
// //         bankIfscCode: selectedBankIfsc,
// //         user_name: username,
// //         mpin,
// //         type: "IMPS1"
// //       };

// //       // ===== IMPS1 STEP 1: SEND OTP =====
// //       if (!showOtpInput) {
// //         const res = await addbeni({
// //           ...imps1Payload,
// //           otp: null,
// //           token: null
// //         });

// //         if (res?.error_code === "DMT001") {
// //           setOtpToken(res?.action_params?.token || "");
// //           setShowOtpInput(true);
// //           return;
// //         }

// //         throw new Error(res?.message || "Failed to send OTP");
// //       }

// //       // ===== IMPS1 STEP 2: VERIFY OTP =====
// //       const res = await addbeni({
// //         ...imps1Payload,
// //         otp,
// //         token: otpToken
// //       });

// //       if (
// //         res?.beneficiary_id &&
// //         SUCCESS_STATUSES.includes(res?.beneficiary_status)
// //       ) {
// //         setPopupMessage("Beneficiary added successfully.");
// //         setPopupType("success");
// //         setNavigateTo("/remittance");
// //         setShowPopup(true);
// //         return;
// //       }

// //       // 👇 HANDLE FAILURE EVEN IF ID EXISTS
// //       if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
// //         throw new Error(
// //           "Beneficiary could not be added due to insufficient wallet balance."
// //         );
// //       }

// //       if (res?.beneficiary_status) {
// //         throw new Error(
// //           res?.message ||
// //           `Failed to add beneficiary (${res.beneficiary_status})`
// //         );
// //       }

// //       throw new Error(res?.message || "OTP verification failed");
// //     } catch (err) {
// //       setPopupMessage(err.message || "Something went wrong.");
// //       setPopupType("error");
// //       setShowPopup(true);
// //     } finally {
// //       setIsLoading(false);
// //       dispatch(fetchWalletBalance());
// //       dispatch(fetchAepsBalance());
// //       dispatch(fetchSettlementBalance());
// //     }
// //   };

// //   const handleCancel = () => {
// //     navigate("/remittance");
// //   };

// //   const handleChange = (fieldName, value) => {
// //     const sanitizedValue =
// //       fieldName === "mobileNumber" || fieldName.includes("Account")
// //         ? value.replace(/\D/g, "")
// //         : value;

// //     switch (fieldName) {
// //       case "accountHolderName":
// //         setAccountHolderName(sanitizedValue);
// //         break;
// //       case "accountNumber":
// //         setAccountNumber(sanitizedValue);
// //         break;
// //       case "confirmAccountNumber":
// //         setConfirmAccountNumber(sanitizedValue);
// //         break;
// //       case "mobileNumber":
// //         setMobileNumber(sanitizedValue);
// //         break;
// //       case "mpin":
// //         setMpin(sanitizedValue);
// //         break;
// //       default:
// //         break;
// //     }

// //     setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
// //   };

// //   return (
// //     <div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">

// //       {/* ===== LEFT INFO PANEL ===== */}
// //       <div className="lg:col-span-1 rounded-2xl p-6 bg-gradient-to-br from-indigo-600 to-indigo-800 text-white shadow-lg">
// //         <h2 className="text-xl font-semibold mb-3">
// //           Add Beneficiary
// //         </h2>

// //         <p className="text-sm text-indigo-100 mb-6">
// //           Enter beneficiary bank details carefully.
// //           Transfers can only be made after successful verification.
// //         </p>

// //         <ul className="space-y-3 text-sm">
// //           <li className="flex gap-2">
// //             <span>✔</span>
// //             <span>Account number must be correct</span>
// //           </li>
// //           <li className="flex gap-2">
// //             <span>✔</span>
// //             <span>IFSC determines the bank</span>
// //           </li>
// //           <li className="flex gap-2">
// //             <span>✔</span>
// //             <span>MPIN is required for security</span>
// //           </li>
// //         </ul>
// //       </div>

// //       {/* ===== RIGHT FORM PANEL ===== */}
// //       {/* <div className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6"> */}
// //       <form autoComplete="off" className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6">

// //         <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
// //         <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />

// //         {/* SECTION: BANK DETAILS */}
// //         <div className="mb-6">
// //           <h3 className="text-sm font-semibold text-slate-700 mb-4">
// //             Bank Details
// //           </h3>

// //           <div className="space-y-4">
// //             {impsType === "IMPS2" && (
// //               <>
// //                 <BankSelect
// //                   ifscInput={ifscCode}
// //                   onIfscChange={(e) => {
// //                     setIfscCode(e.target.value.toUpperCase());
// //                     setErrors((prev) => ({ ...prev, ifscCode: "" }));
// //                   }}
// //                   onSelect={(selected) => {
// //                     setBank(selected.bank_name);
// //                     setBankcode(selected.bank_code);
// //                     setErrors((prev) => ({ ...prev, bank: "" }));
// //                   }}
// //                 />

// //                 {errors.bank && (
// //                   <p className="text-red-500 text-xs mt-1">
// //                     {errors.bank}
// //                   </p>
// //                 )}
// //               </>
// //             )}

// //             {impsType === "IMPS1" && (
// //               <div className="relative">
// //                 {/* SEARCH INPUT */}
// //                 <input
// //                   type="text"
// //                   value={bankSearch}
// //                   placeholder="Search bank name"
// //                   onFocus={() => setShowBankList(true)}
// //                   onChange={(e) => {
// //                     setBankSearch(e.target.value);
// //                     setShowBankList(true);
// //                     setErrors((prev) => ({ ...prev, bank: "" }));
// //                   }}
// //                   className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
// //                 />

// //                 {/* DROPDOWN LIST */}
// //                 {showBankList && (
// //                   <div className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto
// //                       bg-white border rounded-lg shadow-lg">
// //                     {bankList.data
// //                       .filter((bank) =>
// //                         bank.bank_name
// //                           .toLowerCase()
// //                           .includes(bankSearch.toLowerCase())
// //                       )
// //                       .map((bank) => (
// //                         <div
// //                           key={bank.bank_id}
// //                           onClick={() => {
// //                             setSelectedBankId(bank.bank_id);
// //                             setSelectedBankName(bank.bank_name);
// //                             setSelectedBankIfsc(bank.bank_ifsc);
// //                             setBankSearch(bank.bank_name);
// //                             setShowBankList(false);
// //                           }}
// //                           className="px-4 py-2 cursor-pointer hover:bg-indigo-50 text-sm"
// //                         >
// //                           {bank.bank_name}
// //                         </div>
// //                       ))}

// //                     {bankList.data.filter((bank) =>
// //                       bank.bank_name.toLowerCase().includes(bankSearch.toLowerCase())
// //                     ).length === 0 && (
// //                         <div className="px-4 py-2 text-sm text-slate-500">
// //                           No bank found
// //                         </div>
// //                       )}
// //                   </div>
// //                 )}

// //                 {errors.bank && (
// //                   <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
// //                 )}
// //               </div>
// //             )}

// //             {errors.bank && (
// //               <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
// //             )}
// //             {errors.ifscCode && (
// //               <p className="text-red-500 text-xs">{errors.ifscCode}</p>
// //             )}
// //           </div>
// //         </div>

// //         {/* SECTION: ACCOUNT DETAILS */}
// //         <div className="mb-6">
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// //             {/* Account Holder Name */}
// //             <div>
// //               <label className="block text-sm font-medium text-slate-600 mb-1">
// //                 Account Holder Name
// //               </label>
// //               <input
// //                 type="text"
// //                 autoComplete="off"
// //                 value={accountHolderName}
// //                 onChange={(e) => handleChange("accountHolderName", e.target.value)}
// //                 placeholder="Enter Account Holder Name"
// //                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
// //               />
// //               {errors.accountHolderName && (
// //                 <p className="text-red-500 text-xs mt-1">{errors.accountHolderName}</p>
// //               )}
// //             </div>

// //             {/* Mobile Number */}
// //             <div>
// //               <label className="block text-sm font-medium text-slate-600 mb-1">
// //                 Beneficiary Mobile Number
// //               </label>
// //               <input
// //                 type="text"
// //                 autoComplete="tel"
// //                 value={mobileNumber}
// //                 maxLength={10}
// //                 onChange={(e) => handleChange("mobileNumber", e.target.value)}
// //                 placeholder="Enter Mobile Number"
// //                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
// //               />
// //               {errors.mobileNumber && (
// //                 <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>
// //               )}
// //             </div>
// //           </div>

// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
// //             {/* Account Number */}
// //             <div>
// //               <label className="block text-sm font-medium text-slate-600 mb-1">
// //                 Account Number
// //               </label>
// //               <input
// //                 type="text"
// //                 autoComplete="off"
// //                 value={accountNumber}
// //                 maxLength={20}
// //                 onChange={(e) => handleChange("accountNumber", e.target.value)}
// //                 placeholder="Enter Account Number"
// //                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
// //               />
// //             </div>

// //             {/* Confirm Account Number */}
// //             <div>
// //               <label className="block text-sm font-medium text-slate-600 mb-1">
// //                 Confirm Account Number
// //               </label>
// //               <input
// //                 type="text"
// //                 autoComplete="off"
// //                 value={confirmAccountNumber}
// //                 maxLength={20}
// //                 onChange={(e) =>
// //                   handleChange("confirmAccountNumber", e.target.value)
// //                 }
// //                 placeholder="Re-enter Account Number"
// //                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
// //               />
// //             </div>
// //           </div>

// //           {(errors.accountNumber || errors.confirmAccountNumber) && (
// //             <p className="text-red-500 text-xs mt-2">
// //               {errors.accountNumber || errors.confirmAccountNumber}
// //             </p>
// //           )}
// //         </div>

// //         {/* SECTION: SECURITY */}
// //         <div className="mb-6">
// //           <h3 className="text-sm font-semibold text-slate-700 mb-4">
// //             MPIN
// //           </h3>

// //           <input
// //             type="password"
// //             autoComplete="new-password"
// //             value={mpin}
// //             maxLength={6}
// //             onChange={(e) => handleChange("mpin", e.target.value)}
// //             placeholder="Enter 6-digit MPIN"
// //             className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
// //           />
// //           {errors.mpin && (
// //             <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>
// //           )}
// //         </div>

// //         {impsType === "IMPS1" && showOtpInput && (
// //           <div className="mb-6">
// //             <h3 className="text-sm font-semibold text-slate-700 mb-2">
// //               OTP Verification
// //             </h3>

// //             <input
// //               type="text"
// //               autoComplete="one-time-code"
// //               value={otp}
// //               maxLength={6}
// //               onChange={(e) => {
// //                 setOtp(e.target.value.replace(/\D/g, ""));
// //                 setErrors((prev) => ({ ...prev, otp: "" }));
// //               }}
// //               placeholder="Enter 4 or 6 digit OTP"
// //               className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
// //             />

// //             {errors.otp && (
// //               <p className="text-red-500 text-xs mt-1">{errors.otp}</p>
// //             )}
// //           </div>
// //         )}


// //         {/* ACTION BUTTONS */}
// //         <div className="flex justify-end gap-4 pt-4 border-t">
// //           <button
// //             type="button"
// //             onClick={handleCancel}
// //             className="px-6 py-2 rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-100"
// //           >
// //             Cancel
// //           </button>

// //           <button
// //             type="button"
// //             onClick={handleConfirm}
// //             disabled={isLoading}
// //             className={`px-6 py-2 rounded-lg text-white font-semibold
// //             ${isLoading
// //                 ? "bg-slate-400 cursor-not-allowed"
// //                 : "bg-indigo-600 hover:bg-indigo-700"}`}
// //           >
// //             {isLoading ? "Processing..." : "Add Beneficiary"}
// //           </button>
// //         </div>
// //       </form>

// //       {/* POPUP */}
// //       {showPopup && (
// //         <Popup
// //           message={popupMessage}
// //           type={popupType}
// //           onClose={() => {
// //             setShowPopup(false);
// //             setNavigateTo(null);
// //             setNavigateState(null);
// //           }}
// //           navigateTo={navigateTo}
// //           navigateState={navigateState}
// //           showchildren={false}
// //         />
// //       )}
// //     </div>
// //   );


// // };

// // export default AddBeneficiary;



// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Popup from "../../../../ResuableCompoment/Popup";
// import useApi from "../../../../CustomHooks/useApi";
// import BankSelect from "../../../../ResuableCompoment/BankSelect";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../../Store/Slices/WalletSlice";
// import bankList from "./banklist.json";

// const AddBeneficiary = () => {

//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
//   const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
//   const username = useSelector((store) => store.auth.employeeDetails.username);
//   const [bankSearch, setBankSearch] = useState("");
//   const [showBankList, setShowBankList] = useState(false);

//   const impsType = useSelector(
//     (state) => state.auth.remitterData?.type
//   );

//   const [showOtpInput, setShowOtpInput] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [otpToken, setOtpToken] = useState("");
//   const [selectedBankIfsc, setSelectedBankIfsc] = useState("");

//   const [bank, setBank] = useState("");
//   const [ifscCode, setIfscCode] = useState("");
//   const [bankcode, setBankcode] = useState("");
//   const [accountHolderName, setAccountHolderName] = useState("");
//   const [accountNumber, setAccountNumber] = useState("");
//   const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
//   const [mpin, setMpin] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedBankId, setSelectedBankId] = useState("");
//   const [selectedBankName, setSelectedBankName] = useState("");
//   const SUCCESS_STATUSES = ["SUCCESS", "APPROVED", "ACTIVE","UNVERIFIED"];

//   const [popupMessage, setPopupMessage] = useState("");
//   const [popupType, setPopupType] = useState("");
//   const [showPopup, setShowPopup] = useState(false);
//   const [navigateTo, setNavigateTo] = useState(null);
//   const [navigateState, setNavigateState] = useState(null);

//   // ---------- New state for Verify / Without Verify mode ----------
//   const [mode, setMode] = useState(null); // "VERIFY" or "WITHOUT_VERIFY"
//   const [showConfirm, setShowConfirm] = useState(false);

//   const showPopupMessage = (message, type, navigateTo = null, navigateState = null) => {
//     setPopupMessage(message);
//     setPopupType(type);
//     setNavigateTo(navigateTo);
//     setNavigateState(navigateState);
//     setShowPopup(true);
//   };

//   const txnId = `DMT${new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 14)}${Math.floor(1000 + Math.random() * 9000)}`;

//   const { callApi: addbeni } = useApi("/dmt/add/beneficiary", "POST");

//   // ---------- Validation (reused) ----------
//   const validateForm = () => {
//     const newErrors = {};

//     // Common validations
//     if (!accountHolderName) {
//       newErrors.accountHolderName = "Account Holder Name is required.";
//     } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
//       newErrors.accountHolderName =
//         "Account Holder Name can contain only alphabets and spaces.";
//     }

//     if (!accountNumber || accountNumber.length < 6 || accountNumber.length > 20) {
//       newErrors.accountNumber =
//         "Account Number must be between 6 and 20 digits.";
//     }

//     if (confirmAccountNumber !== accountNumber) {
//       newErrors.confirmAccountNumber = "Account numbers do not match.";
//     }

//     if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
//       newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
//     }

//     if (!mpin || !/^\d{6}$/.test(mpin)) {
//       newErrors.mpin = "MPIN must be exactly 6 digits.";
//     }

//     // IMPS2
//     if (impsType === "IMPS2") {
//       if (!bank) newErrors.bank = "Please select a bank";
//       if (!ifscCode) newErrors.ifscCode = "IFSC code is required";
//     }

//     // IMPS1
//     if (impsType === "IMPS1") {
//       if (!selectedBankId) newErrors.bank = "Please select a bank";
//       if (!selectedBankIfsc)
//         newErrors.ifscCode = "Selected bank does not have a valid IFSC";
//     }

//     // OTP step
//     if (impsType === "IMPS1" && showOtpInput) {
//       if (!otp || !/^\d{4}(\d{2})?$/.test(otp)) {
//         newErrors.otp = "Enter a valid 4 or 6 digit OTP.";
//       }
//     }

//     return newErrors;
//   };

//   // ---------- Button click → validate → show modal ----------
//   const handleActionClick = (selectedMode) => {
//     setMode(selectedMode);
//     const validationErrors = validateForm();
//     setErrors(validationErrors);

//     if (Object.keys(validationErrors).length > 0) {
//       return;
//     }

//     setShowConfirm(true);
//   };

//   // ---------- Confirm modal → API call ----------
//   const handleConfirm = async () => {
//     setShowConfirm(false);
//     setIsLoading(true);

//     try {
//       // ================= IMPS2 =================
//       if (impsType === "IMPS2") {
//         const imps2Payload = {
//           remitterPhoneNumber: remitter_mobile_number,
//           remitterName: remitter_fullname,
//           beneficiaryName: accountHolderName,
//           beneficiaryPhoneNumber: mobileNumber,
//           bankName: bank,
//           bankIfscCode: ifscCode,
//           accountNumber,
//           user_name: username,
//           mpin,
//           bank_code: bankcode,
//           type: "IMPS2",
//           account_verify: mode === "VERIFY"   // <-- new flag
//         };

//         const res = await addbeni(imps2Payload);

//         if (
//           res?.beneficiary_id &&
//           SUCCESS_STATUSES.includes(res?.beneficiary_status)
//         ) {
//           showPopupMessage("Beneficiary added successfully.", "success", "/remittance");
//           return;
//         }

//         if (res?.beneficiary_status) {
//           throw new Error(
//             res?.message ||
//             `Failed to add beneficiary (${res.beneficiary_status})`
//           );
//         }

//         if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
//           throw new Error(
//             "Beneficiary could not be added due to insufficient wallet balance."
//           );
//         }

//         throw new Error(res?.message || "Failed to add beneficiary");
//       }

//       // ================= IMPS1 =================
//       const imps1BasePayload = {
//         remitterPhoneNumber: remitter_mobile_number,
//         remitterName: remitter_fullname,
//         beneficiaryName: accountHolderName,
//         beneficiaryPhoneNumber: mobileNumber,
//         accountNumber,
//         bankName: selectedBankId,
//         bank_code: selectedBankId,
//         bankIfscCode: selectedBankIfsc,
//         user_name: username,
//         mpin,
//         type: "IMPS1",
//         account_verify: mode === "VERIFY"   // <-- new flag
//       };

//       // Step 1: send OTP
//       if (!showOtpInput) {
//         const res = await addbeni({
//           ...imps1BasePayload,
//           otp: null,
//           token: null
//         });

//         if (res?.error_code === "DMT001") {
//           setOtpToken(res?.action_params?.token || "");
//           setShowOtpInput(true);
//           setIsLoading(false); // stop loading, user needs to enter OTP
//           return;
//         }

//         throw new Error(res?.message || "Failed to send OTP");
//       }

//       // Step 2: verify OTP
//       const res = await addbeni({
//         ...imps1BasePayload,
//         otp,
//         token: otpToken
//       });

//       if (
//         res?.beneficiary_id &&
//         SUCCESS_STATUSES.includes(res?.beneficiary_status)
//       ) {
//         showPopupMessage("Beneficiary added successfully.", "success", "/remittance");
//         return;
//       }

//       if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
//         throw new Error(
//           "Beneficiary could not be added due to insufficient wallet balance."
//         );
//       }

//       if (res?.beneficiary_status) {
//         throw new Error(
//           res?.message ||
//           `Failed to add beneficiary (${res.beneficiary_status})`
//         );
//       }

//       throw new Error(res?.message || "OTP verification failed");
//     } catch (err) {
//       showPopupMessage(err.message || "Something went wrong.", "error");
//     } finally {
//       setIsLoading(false);
//       dispatch(fetchWalletBalance());
//       dispatch(fetchAepsBalance());
//       dispatch(fetchSettlementBalance());
//     }
//   };

//   const handleCancel = () => {
//     navigate("/remittance");
//   };

//   const handleChange = (fieldName, value) => {
//     const sanitizedValue =
//       fieldName === "mobileNumber" || fieldName.includes("Account")
//         ? value.replace(/\D/g, "")
//         : value;

//     switch (fieldName) {
//       case "accountHolderName":
//         setAccountHolderName(sanitizedValue);
//         break;
//       case "accountNumber":
//         setAccountNumber(sanitizedValue);
//         break;
//       case "confirmAccountNumber":
//         setConfirmAccountNumber(sanitizedValue);
//         break;
//       case "mobileNumber":
//         setMobileNumber(sanitizedValue);
//         break;
//       case "mpin":
//         setMpin(sanitizedValue);
//         break;
//       default:
//         break;
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
//   };

//   return (
//     <div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">

//       {/* ===== LEFT INFO PANEL ===== */}
//       <div className="lg:col-span-1 rounded-2xl p-6 bg-gradient-to-br from-indigo-600 to-indigo-800 text-white shadow-lg">
//         <h2 className="text-xl font-semibold mb-3">
//           Add Beneficiary
//         </h2>

//         <p className="text-sm text-indigo-100 mb-6">
//           Enter beneficiary bank details carefully.
//           Transfers can only be made after successful verification.
//         </p>

//         <ul className="space-y-3 text-sm">
//           <li className="flex gap-2">
//             <span>✔</span>
//             <span>Account number must be correct</span>
//           </li>
//           <li className="flex gap-2">
//             <span>✔</span>
//             <span>IFSC determines the bank</span>
//           </li>
//           <li className="flex gap-2">
//             <span>✔</span>
//             <span>MPIN is required for security</span>
//           </li>
//         </ul>
//       </div>

//       {/* ===== RIGHT FORM PANEL ===== */}
//       <form autoComplete="off" className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6">

//         <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
//         <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />

//         {/* SECTION: BANK DETAILS */}
//         <div className="mb-6">
//           <h3 className="text-sm font-semibold text-slate-700 mb-4">
//             Bank Details
//           </h3>

//           <div className="space-y-4">
//             {impsType === "IMPS2" && (
//               <>
//                 <BankSelect
//                   ifscInput={ifscCode}
//                   onIfscChange={(e) => {
//                     setIfscCode(e.target.value.toUpperCase());
//                     setErrors((prev) => ({ ...prev, ifscCode: "" }));
//                   }}
//                   onSelect={(selected) => {
//                     setBank(selected.bank_name);
//                     setBankcode(selected.bank_code);
//                     setErrors((prev) => ({ ...prev, bank: "" }));
//                   }}
//                 />

//                 {errors.bank && (
//                   <p className="text-red-500 text-xs mt-1">
//                     {errors.bank}
//                   </p>
//                 )}
//               </>
//             )}

//             {impsType === "IMPS1" && (
//               <div className="relative">
//                 {/* SEARCH INPUT */}
//                 <input
//                   type="text"
//                   value={bankSearch}
//                   placeholder="Search bank name"
//                   onFocus={() => setShowBankList(true)}
//                   onChange={(e) => {
//                     setBankSearch(e.target.value);
//                     setShowBankList(true);
//                     setErrors((prev) => ({ ...prev, bank: "" }));
//                   }}
//                   className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
//                 />

//                 {/* DROPDOWN LIST */}
//                 {showBankList && (
//                   <div className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto
//                       bg-white border rounded-lg shadow-lg">
//                     {bankList.data
//                       .filter((bank) =>
//                         bank.bank_name
//                           .toLowerCase()
//                           .includes(bankSearch.toLowerCase())
//                       )
//                       .map((bank) => (
//                         <div
//                           key={bank.bank_id}
//                           onClick={() => {
//                             setSelectedBankId(bank.bank_id);
//                             setSelectedBankName(bank.bank_name);
//                             setSelectedBankIfsc(bank.bank_ifsc);
//                             setBankSearch(bank.bank_name);
//                             setShowBankList(false);
//                           }}
//                           className="px-4 py-2 cursor-pointer hover:bg-indigo-50 text-sm"
//                         >
//                           {bank.bank_name}
//                         </div>
//                       ))}

//                     {bankList.data.filter((bank) =>
//                       bank.bank_name.toLowerCase().includes(bankSearch.toLowerCase())
//                     ).length === 0 && (
//                         <div className="px-4 py-2 text-sm text-slate-500">
//                           No bank found
//                         </div>
//                       )}
//                   </div>
//                 )}

//                 {errors.bank && (
//                   <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
//                 )}
//               </div>
//             )}

//             {errors.bank && (
//               <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
//             )}
//             {errors.ifscCode && (
//               <p className="text-red-500 text-xs">{errors.ifscCode}</p>
//             )}
//           </div>
//         </div>

//         {/* SECTION: ACCOUNT DETAILS */}
//         <div className="mb-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {/* Account Holder Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Account Holder Name
//               </label>
//               <input
//                 type="text"
//                 autoComplete="off"
//                 value={accountHolderName}
//                 onChange={(e) => handleChange("accountHolderName", e.target.value)}
//                 placeholder="Enter Account Holder Name"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//               {errors.accountHolderName && (
//                 <p className="text-red-500 text-xs mt-1">{errors.accountHolderName}</p>
//               )}
//             </div>

//             {/* Mobile Number */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Beneficiary Mobile Number
//               </label>
//               <input
//                 type="text"
//                 autoComplete="tel"
//                 value={mobileNumber}
//                 maxLength={10}
//                 onChange={(e) => handleChange("mobileNumber", e.target.value)}
//                 placeholder="Enter Mobile Number"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//               {errors.mobileNumber && (
//                 <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>
//               )}
//             </div>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//             {/* Account Number */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Account Number
//               </label>
//               <input
//                 type="text"
//                 autoComplete="off"
//                 value={accountNumber}
//                 maxLength={20}
//                 onChange={(e) => handleChange("accountNumber", e.target.value)}
//                 placeholder="Enter Account Number"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//             </div>

//             {/* Confirm Account Number */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Confirm Account Number
//               </label>
//               <input
//                 type="text"
//                 autoComplete="off"
//                 value={confirmAccountNumber}
//                 maxLength={20}
//                 onChange={(e) =>
//                   handleChange("confirmAccountNumber", e.target.value)
//                 }
//                 placeholder="Re-enter Account Number"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//             </div>
//           </div>

//           {(errors.accountNumber || errors.confirmAccountNumber) && (
//             <p className="text-red-500 text-xs mt-2">
//               {errors.accountNumber || errors.confirmAccountNumber}
//             </p>
//           )}
//         </div>

//         {/* SECTION: SECURITY */}
//         <div className="mb-6">
//           <h3 className="text-sm font-semibold text-slate-700 mb-4">
//             MPIN
//           </h3>

//           <input
//             type="password"
//             autoComplete="new-password"
//             value={mpin}
//             maxLength={6}
//             onChange={(e) => handleChange("mpin", e.target.value)}
//             placeholder="Enter 6-digit MPIN"
//             className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
//           />
//           {errors.mpin && (
//             <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>
//           )}
//         </div>

//         {impsType === "IMPS1" && showOtpInput && (
//           <div className="mb-6">
//             <h3 className="text-sm font-semibold text-slate-700 mb-2">
//               OTP Verification
//             </h3>

//             <input
//               type="text"
//               autoComplete="one-time-code"
//               value={otp}
//               maxLength={6}
//               onChange={(e) => {
//                 setOtp(e.target.value.replace(/\D/g, ""));
//                 setErrors((prev) => ({ ...prev, otp: "" }));
//               }}
//               placeholder="Enter 4 or 6 digit OTP"
//               className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
//             />

//             {errors.otp && (
//               <p className="text-red-500 text-xs mt-1">{errors.otp}</p>
//             )}
//           </div>
//         )}


//         {/* ACTION BUTTONS (Verify & Add / Add Without Verify) */}
//         <div className="pt-4 border-t">
//           <div className="flex gap-3">
//             <button
//               type="button"
//               onClick={() => handleActionClick("VERIFY")}
//               className="flex-1 py-3 rounded-xl font-semibold bg-[#12345A] hover:bg-[#0F2E47] text-white"
//             >
//               Verify & Add (₹3)
//             </button>

//             {/* <button
//               type="button"
//               onClick={() => handleActionClick("WITHOUT_VERIFY")}
//               className="flex-1 py-3 rounded-xl font-semibold bg-red-600 hover:bg-red-700 text-white"
//             >
//               Add Without Verify (₹0)
//             </button> */}
//           </div>

//           {/* Cancel button (kept separate if needed) */}
//           <div className="mt-3 flex justify-end">
//             <button
//               type="button"
//               onClick={handleCancel}
//               className="px-6 py-2 rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-100"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       </form>

//       {/* ===== CONFIRMATION MODAL ===== */}
//       {showConfirm && (
//         <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center">
//           <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 sm:p-6 space-y-4">
//             <h3 className="text-base sm:text-lg font-semibold text-slate-800">
//               Confirmation
//             </h3>

//             <p className="text-sm text-slate-700 leading-relaxed">
//               {mode === "VERIFY" ? (
//                 <>
//                   <b>English:</b><br />
//                   <strong>₹3</strong> will be deducted for beneficiary account verification.
//                   <br /><br />
//                   <b>हिंदी:</b><br />
//                   लाभार्थी के खाते के सत्यापन के लिए <strong>₹3</strong> काटे जाएंगे।
//                 </>
//               ) : (
//                 <>
//                   <b>English:</b><br />
//                   <strong>₹0</strong> will be deducted for adding beneficiary without verification.
//                   <br /><br />
//                   <b>हिंदी:</b><br />
//                   बिना सत्यापन के लाभार्थी जोड़ने पर कोई शुल्क नहीं लगेगा।
//                 </>
//               )}
//             </p>

//             <div className="flex gap-3 pt-2">
//               <button
//                 onClick={() => {
//                   setShowConfirm(false);
//                   setMode(null);
//                 }}
//                 className="flex-1 py-3 rounded-xl bg-slate-200 font-semibold"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleConfirm}
//                 disabled={isLoading}
//                 className={`flex-1 py-3 rounded-xl font-semibold text-white ${
//                   isLoading ? "bg-slate-400" : "bg-[#12345A] hover:bg-[#0F2E47]"
//                 }`}
//               >
//                 {isLoading ? "Processing..." : "OK"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* POPUP (unchanged) */}
//       {showPopup && (
//         <Popup
//           message={popupMessage}
//           type={popupType}
//           onClose={() => {
//             setShowPopup(false);
//             setNavigateTo(null);
//             setNavigateState(null);
//           }}
//           navigateTo={navigateTo}
//           navigateState={navigateState}
//           showchildren={false}
//         />
//       )}
//     </div>
//   );
// };

// export default AddBeneficiary;



// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Popup from "../../../../ResuableCompoment/Popup";
// import useApi from "../../../../CustomHooks/useApi";
// import BankSelect from "../../../../ResuableCompoment/BankSelect";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../../Store/Slices/WalletSlice";
// import bankList from "./banklist.json";

// const AddBeneficiary = () => {

//   const location = useLocation();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
//   const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
//   const username = useSelector((store) => store.auth.employeeDetails.username);
//   const [bankSearch, setBankSearch] = useState("");
//   const [showBankList, setShowBankList] = useState(false);

//   const impsType = useSelector(
//     (state) => state.auth.remitterData?.type
//   );

//   const [showOtpInput, setShowOtpInput] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [otpToken, setOtpToken] = useState("");
//   const [selectedBankIfsc, setSelectedBankIfsc] = useState("");

//   const [bank, setBank] = useState("");
//   const [ifscCode, setIfscCode] = useState("");
//   const [bankcode, setBankcode] = useState("");
//   const [accountHolderName, setAccountHolderName] = useState("");
//   const [accountNumber, setAccountNumber] = useState("");
//   const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
//   const [mpin, setMpin] = useState("");
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedBankId, setSelectedBankId] = useState("");
//   const [selectedBankName, setSelectedBankName] = useState("");
//   const SUCCESS_STATUSES = ["SUCCESS", "APPROVED", "ACTIVE"];

//   const [popupMessage, setPopupMessage] = useState("");
//   const [popupType, setPopupType] = useState("");
//   const [showPopup, setShowPopup] = useState(false);
//   const [navigateTo, setNavigateTo] = useState(null);
//   const [navigateState, setNavigateState] = useState(null);

//   const showPopupMessage = (message, type, navigateTo = null, navigateState = null) => {
//     setPopupMessage(message);
//     setPopupType(type);
//     setNavigateTo(navigateTo);
//     setNavigateState(navigateState);
//     setShowPopup(true);
//   };

//   const txnId = `DMT${new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 14)}${Math.floor(1000 + Math.random() * 9000)}`;

//   const { callApi: addbeni } = useApi("/dmt/add/beneficiary", "POST");

//   const handleConfirm = async () => {
//     const newErrors = {};

//     // ---------- COMMON ----------
//     if (!accountHolderName) {
//       newErrors.accountHolderName = "Account Holder Name is required.";
//     } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
//       newErrors.accountHolderName =
//         "Account Holder Name can contain only alphabets and spaces.";
//     }

//     if (!accountNumber || accountNumber.length < 6 || accountNumber.length > 20) {
//       newErrors.accountNumber =
//         "Account Number must be between 6 and 20 digits.";
//     }

//     if (confirmAccountNumber !== accountNumber) {
//       newErrors.confirmAccountNumber = "Account numbers do not match.";
//     }

//     if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
//       newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
//     }

//     if (!mpin || !/^\d{6}$/.test(mpin)) {
//       newErrors.mpin = "MPIN must be exactly 6 digits.";
//     }

//     // ---------- IMPS2 (ORIGINAL) ----------
//     if (impsType === "IMPS2") {
//       if (!bank) newErrors.bank = "Please select a bank";
//       if (!ifscCode) newErrors.ifscCode = "IFSC code is required";
//     }

//     // ---------- IMPS1 (NEW) ----------
//     if (impsType === "IMPS1") {
//       if (!selectedBankId) newErrors.bank = "Please select a bank";
//       if (!selectedBankIfsc)
//         newErrors.ifscCode = "Selected bank does not have a valid IFSC";
//     }

//     // ---------- OTP (IMPS1 STEP 2) ----------
//     if (impsType === "IMPS1" && showOtpInput) {
//       if (!otp || !/^\d{4}(\d{2})?$/.test(otp)) {
//         newErrors.otp = "Enter a valid 4 or 6 digit OTP.";
//       }
//     }

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }

//     setIsLoading(true);

//     try {
//       // ================= IMPS2 (ORIGINAL PAYLOAD) =================
//       if (impsType === "IMPS2") {
//         const imps2Payload = {
//           remitterPhoneNumber: remitter_mobile_number,
//           remitterName: remitter_fullname,
//           beneficiaryName: accountHolderName,
//           beneficiaryPhoneNumber: mobileNumber,
//           bankName: bank,
//           bankIfscCode: ifscCode,
//           accountNumber,
//           user_name: username,
//           mpin,
//           bank_code: bankcode,
//           type: "IMPS2"
//         };

//         const res = await addbeni(imps2Payload);

//         const SUCCESS_STATUSES = ["SUCCESS", "APPROVED", "ACTIVE"];

//         if (
//           res?.beneficiary_id &&
//           SUCCESS_STATUSES.includes(res?.beneficiary_status)
//         ) {
//           setPopupMessage("Beneficiary added successfully.");
//           setPopupType("success");
//           setNavigateTo("/remittance");
//           setShowPopup(true);
//           return;
//         }

//         if (res?.beneficiary_status) {
//           throw new Error(
//             res?.message ||
//             `Failed to add beneficiary (${res.beneficiary_status})`
//           );
//         }

//         // 👇 HANDLE FAILURE EVEN IF ID EXISTS
//         if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
//           throw new Error(
//             "Beneficiary could not be added due to insufficient wallet balance."
//           );
//         }

//         throw new Error(res?.message || "Failed to add beneficiary");
//       }

//       // ================= IMPS1 (NEW PAYLOAD) =================
//       const imps1Payload = {
//         remitterPhoneNumber: remitter_mobile_number,
//         remitterName: remitter_fullname,
//         beneficiaryName: accountHolderName,
//         beneficiaryPhoneNumber: mobileNumber,
//         accountNumber,
//         bankName: selectedBankId,
//         bank_code: selectedBankId,
//         bankIfscCode: selectedBankIfsc,
//         user_name: username,
//         mpin,
//         type: "IMPS1"
//       };

//       // ===== IMPS1 STEP 1: SEND OTP =====
//       if (!showOtpInput) {
//         const res = await addbeni({
//           ...imps1Payload,
//           otp: null,
//           token: null
//         });

//         if (res?.error_code === "DMT001") {
//           setOtpToken(res?.action_params?.token || "");
//           setShowOtpInput(true);
//           return;
//         }

//         throw new Error(res?.message || "Failed to send OTP");
//       }

//       // ===== IMPS1 STEP 2: VERIFY OTP =====
//       const res = await addbeni({
//         ...imps1Payload,
//         otp,
//         token: otpToken
//       });

//       if (
//         res?.beneficiary_id &&
//         SUCCESS_STATUSES.includes(res?.beneficiary_status)
//       ) {
//         setPopupMessage("Beneficiary added successfully.");
//         setPopupType("success");
//         setNavigateTo("/remittance");
//         setShowPopup(true);
//         return;
//       }

//       // 👇 HANDLE FAILURE EVEN IF ID EXISTS
//       if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
//         throw new Error(
//           "Beneficiary could not be added due to insufficient wallet balance."
//         );
//       }

//       if (res?.beneficiary_status) {
//         throw new Error(
//           res?.message ||
//           `Failed to add beneficiary (${res.beneficiary_status})`
//         );
//       }

//       throw new Error(res?.message || "OTP verification failed");
//     } catch (err) {
//       setPopupMessage(err.message || "Something went wrong.");
//       setPopupType("error");
//       setShowPopup(true);
//     } finally {
//       setIsLoading(false);
//       dispatch(fetchWalletBalance());
//       dispatch(fetchAepsBalance());
//       dispatch(fetchSettlementBalance());
//     }
//   };

//   const handleCancel = () => {
//     navigate("/remittance");
//   };

//   const handleChange = (fieldName, value) => {
//     const sanitizedValue =
//       fieldName === "mobileNumber" || fieldName.includes("Account")
//         ? value.replace(/\D/g, "")
//         : value;

//     switch (fieldName) {
//       case "accountHolderName":
//         setAccountHolderName(sanitizedValue);
//         break;
//       case "accountNumber":
//         setAccountNumber(sanitizedValue);
//         break;
//       case "confirmAccountNumber":
//         setConfirmAccountNumber(sanitizedValue);
//         break;
//       case "mobileNumber":
//         setMobileNumber(sanitizedValue);
//         break;
//       case "mpin":
//         setMpin(sanitizedValue);
//         break;
//       default:
//         break;
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
//   };

//   return (
//     <div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">

//       {/* ===== LEFT INFO PANEL ===== */}
//       <div className="lg:col-span-1 rounded-2xl p-6 bg-gradient-to-br from-indigo-600 to-indigo-800 text-white shadow-lg">
//         <h2 className="text-xl font-semibold mb-3">
//           Add Beneficiary
//         </h2>

//         <p className="text-sm text-indigo-100 mb-6">
//           Enter beneficiary bank details carefully.
//           Transfers can only be made after successful verification.
//         </p>

//         <ul className="space-y-3 text-sm">
//           <li className="flex gap-2">
//             <span>✔</span>
//             <span>Account number must be correct</span>
//           </li>
//           <li className="flex gap-2">
//             <span>✔</span>
//             <span>IFSC determines the bank</span>
//           </li>
//           <li className="flex gap-2">
//             <span>✔</span>
//             <span>MPIN is required for security</span>
//           </li>
//         </ul>
//       </div>

//       {/* ===== RIGHT FORM PANEL ===== */}
//       {/* <div className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6"> */}
//       <form autoComplete="off" className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6">

//         <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
//         <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />

//         {/* SECTION: BANK DETAILS */}
//         <div className="mb-6">
//           <h3 className="text-sm font-semibold text-slate-700 mb-4">
//             Bank Details
//           </h3>

//           <div className="space-y-4">
//             {impsType === "IMPS2" && (
//               <>
//                 <BankSelect
//                   ifscInput={ifscCode}
//                   onIfscChange={(e) => {
//                     setIfscCode(e.target.value.toUpperCase());
//                     setErrors((prev) => ({ ...prev, ifscCode: "" }));
//                   }}
//                   onSelect={(selected) => {
//                     setBank(selected.bank_name);
//                     setBankcode(selected.bank_code);
//                     setErrors((prev) => ({ ...prev, bank: "" }));
//                   }}
//                 />

//                 {errors.bank && (
//                   <p className="text-red-500 text-xs mt-1">
//                     {errors.bank}
//                   </p>
//                 )}
//               </>
//             )}

//             {impsType === "IMPS1" && (
//               <div className="relative">
//                 {/* SEARCH INPUT */}
//                 <input
//                   type="text"
//                   value={bankSearch}
//                   placeholder="Search bank name"
//                   onFocus={() => setShowBankList(true)}
//                   onChange={(e) => {
//                     setBankSearch(e.target.value);
//                     setShowBankList(true);
//                     setErrors((prev) => ({ ...prev, bank: "" }));
//                   }}
//                   className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
//                 />

//                 {/* DROPDOWN LIST */}
//                 {showBankList && (
//                   <div className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto
//                       bg-white border rounded-lg shadow-lg">
//                     {bankList.data
//                       .filter((bank) =>
//                         bank.bank_name
//                           .toLowerCase()
//                           .includes(bankSearch.toLowerCase())
//                       )
//                       .map((bank) => (
//                         <div
//                           key={bank.bank_id}
//                           onClick={() => {
//                             setSelectedBankId(bank.bank_id);
//                             setSelectedBankName(bank.bank_name);
//                             setSelectedBankIfsc(bank.bank_ifsc);
//                             setBankSearch(bank.bank_name);
//                             setShowBankList(false);
//                           }}
//                           className="px-4 py-2 cursor-pointer hover:bg-indigo-50 text-sm"
//                         >
//                           {bank.bank_name}
//                         </div>
//                       ))}

//                     {bankList.data.filter((bank) =>
//                       bank.bank_name.toLowerCase().includes(bankSearch.toLowerCase())
//                     ).length === 0 && (
//                         <div className="px-4 py-2 text-sm text-slate-500">
//                           No bank found
//                         </div>
//                       )}
//                   </div>
//                 )}

//                 {errors.bank && (
//                   <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
//                 )}
//               </div>
//             )}

//             {errors.bank && (
//               <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
//             )}
//             {errors.ifscCode && (
//               <p className="text-red-500 text-xs">{errors.ifscCode}</p>
//             )}
//           </div>
//         </div>

//         {/* SECTION: ACCOUNT DETAILS */}
//         <div className="mb-6">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {/* Account Holder Name */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Account Holder Name
//               </label>
//               <input
//                 type="text"
//                 autoComplete="off"
//                 value={accountHolderName}
//                 onChange={(e) => handleChange("accountHolderName", e.target.value)}
//                 placeholder="Enter Account Holder Name"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//               {errors.accountHolderName && (
//                 <p className="text-red-500 text-xs mt-1">{errors.accountHolderName}</p>
//               )}
//             </div>

//             {/* Mobile Number */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Beneficiary Mobile Number
//               </label>
//               <input
//                 type="text"
//                 autoComplete="tel"
//                 value={mobileNumber}
//                 maxLength={10}
//                 onChange={(e) => handleChange("mobileNumber", e.target.value)}
//                 placeholder="Enter Mobile Number"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//               {errors.mobileNumber && (
//                 <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>
//               )}
//             </div>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//             {/* Account Number */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Account Number
//               </label>
//               <input
//                 type="text"
//                 autoComplete="off"
//                 value={accountNumber}
//                 maxLength={20}
//                 onChange={(e) => handleChange("accountNumber", e.target.value)}
//                 placeholder="Enter Account Number"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//             </div>

//             {/* Confirm Account Number */}
//             <div>
//               <label className="block text-sm font-medium text-slate-600 mb-1">
//                 Confirm Account Number
//               </label>
//               <input
//                 type="text"
//                 autoComplete="off"
//                 value={confirmAccountNumber}
//                 maxLength={20}
//                 onChange={(e) =>
//                   handleChange("confirmAccountNumber", e.target.value)
//                 }
//                 placeholder="Re-enter Account Number"
//                 className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
//               />
//             </div>
//           </div>

//           {(errors.accountNumber || errors.confirmAccountNumber) && (
//             <p className="text-red-500 text-xs mt-2">
//               {errors.accountNumber || errors.confirmAccountNumber}
//             </p>
//           )}
//         </div>

//         {/* SECTION: SECURITY */}
//         <div className="mb-6">
//           <h3 className="text-sm font-semibold text-slate-700 mb-4">
//             MPIN
//           </h3>

//           <input
//             type="password"
//             autoComplete="new-password"
//             value={mpin}
//             maxLength={6}
//             onChange={(e) => handleChange("mpin", e.target.value)}
//             placeholder="Enter 6-digit MPIN"
//             className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
//           />
//           {errors.mpin && (
//             <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>
//           )}
//         </div>

//         {impsType === "IMPS1" && showOtpInput && (
//           <div className="mb-6">
//             <h3 className="text-sm font-semibold text-slate-700 mb-2">
//               OTP Verification
//             </h3>

//             <input
//               type="text"
//               autoComplete="one-time-code"
//               value={otp}
//               maxLength={6}
//               onChange={(e) => {
//                 setOtp(e.target.value.replace(/\D/g, ""));
//                 setErrors((prev) => ({ ...prev, otp: "" }));
//               }}
//               placeholder="Enter 4 or 6 digit OTP"
//               className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
//             />

//             {errors.otp && (
//               <p className="text-red-500 text-xs mt-1">{errors.otp}</p>
//             )}
//           </div>
//         )}


//         {/* ACTION BUTTONS */}
//         <div className="flex justify-end gap-4 pt-4 border-t">
//           <button
//             type="button"
//             onClick={handleCancel}
//             className="px-6 py-2 rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-100"
//           >
//             Cancel
//           </button>

//           <button
//             type="button"
//             onClick={handleConfirm}
//             disabled={isLoading}
//             className={`px-6 py-2 rounded-lg text-white font-semibold
//             ${isLoading
//                 ? "bg-slate-400 cursor-not-allowed"
//                 : "bg-indigo-600 hover:bg-indigo-700"}`}
//           >
//             {isLoading ? "Processing..." : "Add Beneficiary"}
//           </button>
//         </div>
//       </form>

//       {/* POPUP */}
//       {showPopup && (
//         <Popup
//           message={popupMessage}
//           type={popupType}
//           onClose={() => {
//             setShowPopup(false);
//             setNavigateTo(null);
//             setNavigateState(null);
//           }}
//           navigateTo={navigateTo}
//           navigateState={navigateState}
//           showchildren={false}
//         />
//       )}
//     </div>
//   );


// };

// export default AddBeneficiary;



import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Popup from "../../../../ResuableCompoment/Popup";
import useApi from "../../../../CustomHooks/useApi";
import BankSelect from "../../../../ResuableCompoment/BankSelect";
import { useSelector, useDispatch } from "react-redux";
import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../../Store/Slices/WalletSlice";
import bankList from "./banklist.json";

const AddBeneficiary = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
  const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
  const username = useSelector((store) => store.auth.employeeDetails.username);
  const [bankSearch, setBankSearch] = useState("");
  const [showBankList, setShowBankList] = useState(false);

  const impsType = useSelector(
    (state) => state.auth.remitterData?.type
  );

  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [selectedBankIfsc, setSelectedBankIfsc] = useState("");

  const [bank, setBank] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [bankcode, setBankcode] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [mpin, setMpin] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const SUCCESS_STATUSES = ["SUCCESS", "APPROVED", "ACTIVE","UNVERIFIED"];

  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [navigateTo, setNavigateTo] = useState(null);
  const [navigateState, setNavigateState] = useState(null);

  // ---------- New state for Verify / Without Verify mode ----------
  const [mode, setMode] = useState(null); // "VERIFY" or "WITHOUT_VERIFY"
  const [showConfirm, setShowConfirm] = useState(false);

  const showPopupMessage = (message, type, navigateTo = null, navigateState = null) => {
    setPopupMessage(message);
    setPopupType(type);
    setNavigateTo(navigateTo);
    setNavigateState(navigateState);
    setShowPopup(true);
  };

  const txnId = `DMT${new Date().toISOString().replace(/[-:.TZ]/g, "").slice(0, 14)}${Math.floor(1000 + Math.random() * 9000)}`;

  const { callApi: addbeni } = useApi("/dmt/add/beneficiary", "POST");

  // ---------- Validation (reused) ----------
  const validateForm = () => {
    const newErrors = {};

    

    // Common validations
    if (!accountHolderName) {
      newErrors.accountHolderName = "Account Holder Name is required.";
    } else if (!/^[A-Za-z\s]+$/.test(accountHolderName)) {
      newErrors.accountHolderName =
        "Account Holder Name can contain only alphabets and spaces.";
    }

    // if (!accountNumber || accountNumber.length < 6 || accountNumber.length > 20) {
    //   newErrors.accountNumber =
    //     "Account Number must be between 6 and 20 digits.";
    // }

    // if (confirmAccountNumber !== accountNumber) {
    //   newErrors.confirmAccountNumber = "Account numbers do not match.";
    // }

    // Replace the old accountNumber check with:
   // Account number checks
    const acc = (accountNumber || "").trim().toUpperCase();
    const confirmAcc = (confirmAccountNumber || "").trim().toUpperCase();

    if (!acc || acc.length < 6 || acc.length > 20) {
      newErrors.accountNumber =
        "Account Number must be between 6 and 20 alphanumeric characters.";
    } else if (!/^[A-Z0-9]+$/.test(acc)) {
      newErrors.accountNumber =
        "Account Number can contain only letters and digits.";
    }

    if (confirmAcc !== acc) {
      newErrors.confirmAccountNumber = "Account numbers do not match.";
    }

    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid 10-digit mobile number.";
    }

    if (!mpin || !/^\d{6}$/.test(mpin)) {
      newErrors.mpin = "MPIN must be exactly 6 digits.";
    }

    // IMPS2
    if (impsType === "IMPS2") {
      if (!bank) newErrors.bank = "Please select a bank";
      if (!ifscCode) newErrors.ifscCode = "IFSC code is required";
    }

    // IMPS1
    if (impsType === "IMPS1") {
      if (!selectedBankId) newErrors.bank = "Please select a bank";
      if (!selectedBankIfsc)
        newErrors.ifscCode = "Selected bank does not have a valid IFSC";
    }

    // OTP step
    if (impsType === "IMPS1" && showOtpInput) {
      if (!otp || !/^\d{4}(\d{2})?$/.test(otp)) {
        newErrors.otp = "Enter a valid 4 or 6 digit OTP.";
      }
    }

    return newErrors;
  };

  // ---------- Button click → validate → show modal ----------
  const handleActionClick = (selectedMode) => {
    setMode(selectedMode);
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    setShowConfirm(true);
  };

  // ---------- Confirm modal → API call ----------
  const handleConfirm = async () => {
    setShowConfirm(false);
    setIsLoading(true);

    try {
      // ================= IMPS2 =================
      if (impsType === "IMPS2") {
        const imps2Payload = {
          remitterPhoneNumber: remitter_mobile_number,
          remitterName: remitter_fullname,
          beneficiaryName: accountHolderName,
          beneficiaryPhoneNumber: mobileNumber,
          bankName: bank,
          bankIfscCode: ifscCode,
          accountNumber,
          user_name: username,
          mpin,
          bank_code: bankcode,
          type: "IMPS2",
          account_verify: mode === "VERIFY"   // <-- new flag
        };

        const res = await addbeni(imps2Payload);

        if (
          res?.beneficiary_id &&
          SUCCESS_STATUSES.includes(res?.beneficiary_status)
        ) {
          showPopupMessage("Beneficiary added successfully.", "success", "/remittance");
          return;
        }

        if (res?.beneficiary_status) {
          throw new Error(
            res?.message ||
            `Failed to add beneficiary (${res.beneficiary_status})`
          );
        }

        if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
          throw new Error(
            "Beneficiary could not be added due to insufficient wallet balance."
          );
        }

        throw new Error(res?.message || "Failed to add beneficiary");
      }

      // ================= IMPS1 =================
      const imps1BasePayload = {
        remitterPhoneNumber: remitter_mobile_number,
        remitterName: remitter_fullname,
        beneficiaryName: accountHolderName,
        beneficiaryPhoneNumber: mobileNumber,
        accountNumber,
        bankName: selectedBankId,
        bank_code: selectedBankId,
        bankIfscCode: selectedBankIfsc,
        user_name: username,
        mpin,
        type: "IMPS1",
        account_verify: mode === "VERIFY"   // <-- new flag
      };

      // Step 1: send OTP
      if (!showOtpInput) {
        const res = await addbeni({
          ...imps1BasePayload,
          otp: null,
          token: null
        });

        if (res?.error_code === "DMT001") {
          setOtpToken(res?.action_params?.token || "");
          setShowOtpInput(true);
          setIsLoading(false); // stop loading, user needs to enter OTP
          return;
        }

        throw new Error(res?.message || "Failed to send OTP");
      }

      // Step 2: verify OTP
      const res = await addbeni({
        ...imps1BasePayload,
        otp,
        token: otpToken
      });

      if (
        res?.beneficiary_id &&
        SUCCESS_STATUSES.includes(res?.beneficiary_status)
      ) {
        showPopupMessage("Beneficiary added successfully.", "success", "/remittance");
        return;
      }

      if (res?.beneficiary_status === "WALLET_DEBIT_FAILED") {
        throw new Error(
          "Beneficiary could not be added due to insufficient wallet balance."
        );
      }

      if (res?.beneficiary_status) {
        throw new Error(
          res?.message ||
          `Failed to add beneficiary (${res.beneficiary_status})`
        );
      }

      throw new Error(res?.message || "OTP verification failed");
    } catch (err) {
      showPopupMessage(err.message || "Something went wrong.", "error");
    } finally {
      setIsLoading(false);
      dispatch(fetchWalletBalance());
      dispatch(fetchAepsBalance());
      dispatch(fetchSettlementBalance());
    }
  };

  const handleCancel = () => {
    navigate("/remittance");
  };

  // const handleChange = (fieldName, value) => {
  //   const sanitizedValue =
  //     fieldName === "mobileNumber" || fieldName.includes("Account")
  //       ? value.replace(/\D/g, "")
  //       : value;

  //   switch (fieldName) {
  //     case "accountHolderName":
  //       setAccountHolderName(sanitizedValue);
  //       break;
  //     case "accountNumber":
  //       setAccountNumber(sanitizedValue);
  //       break;
  //     case "confirmAccountNumber":
  //       setConfirmAccountNumber(sanitizedValue);
  //       break;
  //     case "mobileNumber":
  //       setMobileNumber(sanitizedValue);
  //       break;
  //     case "mpin":
  //       setMpin(sanitizedValue);
  //       break;
  //     default:
  //       break;
  //   }

  //   setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
  // };


  const handleChange = (fieldName, value) => {
    let sanitizedValue = value;

    if (fieldName === "mobileNumber" || fieldName === "mpin") {
      sanitizedValue = value.replace(/\D/g, ""); // Only digits
    } else if (fieldName.toLowerCase().includes("account")) {
      // ✅ Now catches both "accountNumber" and "confirmAccountNumber"
      sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    }

    switch (fieldName) {
      case "accountHolderName":
        setAccountHolderName(sanitizedValue);
        break;
      case "accountNumber":
        setAccountNumber(sanitizedValue);
        break;
      case "confirmAccountNumber":
        setConfirmAccountNumber(sanitizedValue);
        break;
      case "mobileNumber":
        setMobileNumber(sanitizedValue);
        break;
      case "mpin":
        setMpin(sanitizedValue);
        break;
      default:
        break;
    }

    // Clear related account number errors whenever either field changes
    if (fieldName.toLowerCase().includes("account")) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        accountNumber: "",
        confirmAccountNumber: "",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    }
  };

  return (
    <div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8">

      {/* ===== LEFT INFO PANEL ===== */}
      <div className="lg:col-span-1 rounded-2xl p-6 bg-gradient-to-br from-indigo-600 to-indigo-800 text-white shadow-lg">
        <h2 className="text-xl font-semibold mb-3">
          Add Beneficiary
        </h2>

        <p className="text-sm text-indigo-100 mb-6">
          Enter beneficiary bank details carefully.
          Transfers can only be made after successful verification.
        </p>

        <ul className="space-y-3 text-sm">
          <li className="flex gap-2">
            <span>✔</span>
            <span>Account number must be correct</span>
          </li>
          <li className="flex gap-2">
            <span>✔</span>
            <span>IFSC determines the bank</span>
          </li>
          <li className="flex gap-2">
            <span>✔</span>
            <span>MPIN is required for security</span>
          </li>
        </ul>
      </div>

      {/* ===== RIGHT FORM PANEL ===== */}
      <form autoComplete="off" className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6">

        <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
        <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />

        {/* SECTION: BANK DETAILS */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-slate-700 mb-4">
            Bank Details
          </h3>

          <div className="space-y-4">
            {impsType === "IMPS2" && (
              <>
                <BankSelect
                  ifscInput={ifscCode}
                  onIfscChange={(e) => {
                    setIfscCode(e.target.value.toUpperCase());
                    setErrors((prev) => ({ ...prev, ifscCode: "" }));
                  }}
                  onSelect={(selected) => {
                    setBank(selected.bank_name);
                    setBankcode(selected.bank_code);
                    setErrors((prev) => ({ ...prev, bank: "" }));
                  }}
                />

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.bank}
                  </p>
                )}
              </>
            )}

            {impsType === "IMPS1" && (
              <div className="relative">
                {/* SEARCH INPUT */}
                <input
                  type="text"
                  value={bankSearch}
                  placeholder="Search bank name"
                  onFocus={() => setShowBankList(true)}
                  onChange={(e) => {
                    setBankSearch(e.target.value);
                    setShowBankList(true);
                    setErrors((prev) => ({ ...prev, bank: "" }));
                  }}
                  className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
                />

                {/* DROPDOWN LIST */}
                {showBankList && (
                  <div className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto
                      bg-white border rounded-lg shadow-lg">
                    {bankList.data
                      .filter((bank) =>
                        bank.bank_name
                          .toLowerCase()
                          .includes(bankSearch.toLowerCase())
                      )
                      .map((bank) => (
                        <div
                          key={bank.bank_id}
                          onClick={() => {
                            setSelectedBankId(bank.bank_id);
                            setSelectedBankName(bank.bank_name);
                            setSelectedBankIfsc(bank.bank_ifsc);
                            setBankSearch(bank.bank_name);
                            setShowBankList(false);
                          }}
                          className="px-4 py-2 cursor-pointer hover:bg-indigo-50 text-sm"
                        >
                          {bank.bank_name}
                        </div>
                      ))}

                    {bankList.data.filter((bank) =>
                      bank.bank_name.toLowerCase().includes(bankSearch.toLowerCase())
                    ).length === 0 && (
                        <div className="px-4 py-2 text-sm text-slate-500">
                          No bank found
                        </div>
                      )}
                  </div>
                )}

                {errors.bank && (
                  <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
                )}
              </div>
            )}

            {errors.bank && (
              <p className="text-red-500 text-xs mt-1">{errors.bank}</p>
            )}
            {errors.ifscCode && (
              <p className="text-red-500 text-xs">{errors.ifscCode}</p>
            )}
          </div>
        </div>

        {/* SECTION: ACCOUNT DETAILS */}
        <div className="mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Account Holder Name */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Account Holder Name
              </label>
              <input
                type="text"
                autoComplete="off"
                value={accountHolderName}
                onChange={(e) => handleChange("accountHolderName", e.target.value)}
                placeholder="Enter Account Holder Name"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
              {errors.accountHolderName && (
                <p className="text-red-500 text-xs mt-1">{errors.accountHolderName}</p>
              )}
            </div>

            {/* Mobile Number */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Beneficiary Mobile Number
              </label>
              <input
                type="text"
                autoComplete="tel"
                value={mobileNumber}
                maxLength={10}
                onChange={(e) => handleChange("mobileNumber", e.target.value)}
                placeholder="Enter Mobile Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
              {errors.mobileNumber && (
                <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>
              )}
            </div>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            Account Number
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Account Number
              </label>
              <input
                type="text"
                autoComplete="off"
                value={accountNumber}
                maxLength={20}
                onChange={(e) => handleChange("accountNumber", e.target.value)}
                placeholder="Enter Account Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            Confirm Account Number
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Confirm Account Number
              </label>
              <input
                type="text"
                autoComplete="off"
                value={confirmAccountNumber}
                maxLength={20}
                onChange={(e) =>
                  handleChange("confirmAccountNumber", e.target.value)
                }
                placeholder="Re-enter Account Number"
                className="border rounded-lg px-4 py-2 w-full focus:ring-2 focus:ring-indigo-500"
              />
            </div>
          </div> */}


          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {/* Account Number */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Account Number
              </label>
              <input
                type="text"
                autoComplete="off"
                value={accountNumber}
                maxLength={20}
                onChange={(e) => handleChange("accountNumber", e.target.value)}
                placeholder="Enter Account Number"
                className="border rounded-lg px-4 py-2 w-full uppercase focus:ring-2 focus:ring-indigo-500"
              />
              {errors.accountNumber && (
                <p className="text-red-500 text-xs mt-1">{errors.accountNumber}</p>
              )}
            </div>

            {/* Confirm Account Number */}
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Confirm Account Number
              </label>
              <input
                type="text"
                autoComplete="off"
                value={confirmAccountNumber}
                maxLength={20}
                onChange={(e) =>
                  handleChange("confirmAccountNumber", e.target.value)
                }
                placeholder="Re-enter Account Number"
                className="border rounded-lg px-4 py-2 w-full uppercase focus:ring-2 focus:ring-indigo-500"
              />
              {errors.confirmAccountNumber && (
                <p className="text-red-500 text-xs mt-1">{errors.confirmAccountNumber}</p>
              )}
            </div>
          </div>
          
          {(errors.accountNumber || errors.confirmAccountNumber) && (
            <p className="text-red-500 text-xs mt-2">
              {errors.accountNumber || errors.confirmAccountNumber}
            </p>
          )}
        </div>

        {/* SECTION: SECURITY */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-slate-700 mb-4">
            MPIN
          </h3>

          <input
            type="password"
            autoComplete="new-password"
            value={mpin}
            maxLength={6}
            onChange={(e) => handleChange("mpin", e.target.value)}
            placeholder="Enter 6-digit MPIN"
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
          />
          {errors.mpin && (
            <p className="text-red-500 text-xs mt-1">{errors.mpin}</p>
          )}
        </div>

        {impsType === "IMPS1" && showOtpInput && (
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-slate-700 mb-2">
              OTP Verification
            </h3>

            <input
              type="text"
              autoComplete="one-time-code"
              value={otp}
              maxLength={6}
              onChange={(e) => {
                setOtp(e.target.value.replace(/\D/g, ""));
                setErrors((prev) => ({ ...prev, otp: "" }));
              }}
              placeholder="Enter 4 or 6 digit OTP"
              className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-500"
            />

            {errors.otp && (
              <p className="text-red-500 text-xs mt-1">{errors.otp}</p>
            )}
          </div>
        )}


        {/* ACTION BUTTONS (Verify & Add / Add Without Verify) */}
        <div className="pt-4 border-t">
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => handleActionClick("VERIFY")}
              className="flex-1 py-3 rounded-xl font-semibold bg-[#12345A] hover:bg-[#0F2E47] text-white"
            >
              Verify & Add (₹3)
            </button>

            {/* <button
              type="button"
              onClick={() => handleActionClick("WITHOUT_VERIFY")}
              className="flex-1 py-3 rounded-xl font-semibold bg-red-600 hover:bg-red-700 text-white"
            >
              Add Without Verify (₹0)
            </button> */}
          </div>

          {/* Cancel button (kept separate if needed) */}
          <div className="mt-3 flex justify-end">
            <button
              type="button"
              onClick={handleCancel}
              className="px-6 py-2 rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-100"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>

      {/* ===== CONFIRMATION MODAL ===== */}
      {showConfirm && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center">
          <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 sm:p-6 space-y-4">
            <h3 className="text-base sm:text-lg font-semibold text-slate-800">
              Confirmation
            </h3>

            <p className="text-sm text-slate-700 leading-relaxed">
              {mode === "VERIFY" ? (
                <>
                  <b>English:</b><br />
                  <strong>₹3</strong> will be deducted for beneficiary account verification.
                  <br /><br />
                  <b>हिंदी:</b><br />
                  लाभार्थी के खाते के सत्यापन के लिए <strong>₹3</strong> काटे जाएंगे।
                </>
              ) : (
                <>
                  <b>English:</b><br />
                  <strong>₹0</strong> will be deducted for adding beneficiary without verification.
                  <br /><br />
                  <b>हिंदी:</b><br />
                  बिना सत्यापन के लाभार्थी जोड़ने पर कोई शुल्क नहीं लगेगा।
                </>
              )}
            </p>

            <div className="flex gap-3 pt-2">
              <button
                onClick={() => {
                  setShowConfirm(false);
                  setMode(null);
                }}
                className="flex-1 py-3 rounded-xl bg-slate-200 font-semibold"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={isLoading}
                className={`flex-1 py-3 rounded-xl font-semibold text-white ${
                  isLoading ? "bg-slate-400" : "bg-[#12345A] hover:bg-[#0F2E47]"
                }`}
              >
                {isLoading ? "Processing..." : "OK"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* POPUP (unchanged) */}
      {showPopup && (
        <Popup
          message={popupMessage}
          type={popupType}
          onClose={() => {
            setShowPopup(false);
            setNavigateTo(null);
            setNavigateState(null);
          }}
          navigateTo={navigateTo}
          navigateState={navigateState}
          showchildren={false}
        />
      )}
    </div>
  );
};

export default AddBeneficiary;